exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section--2dG9h {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  width: 100%;\n}\n\n.buttons--DdwFb {\n  display: -ms-flexbox;\n  display: flex;\n  padding: 10px;\n}\n\n.buttons--DdwFb > * {\n  margin: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"section": "section--2dG9h",
	"buttons": "buttons--DdwFb"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/containers/Public/pages/SocketsTesting/SocketsTesting.m.scss
// module id = 1606
// module chunks = 0